// Generat automat din README.md - Phase 3: Dashboard Executiv Enterprise
import React, { useState, useEffect } from 'react';
import { 
  TrendingUp, 
  TrendingDown,
  Users, 
  DollarSign, 
  Target,
  BarChart3,
  PieChart,
  Activity,
  Calendar,
  Clock,
  AlertTriangle,
  CheckCircle,
  ArrowUpRight,
  ArrowDownRight,
  Filter,
  Download,
  RefreshCw,
  Eye,
  Settings,
  ChevronRight,
  Zap,
  Building,
  Globe,
  Shield
} from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const DashboardExecutiv = () => {
  const [intervalTimp, setIntervalTimp] = useState('30z');
  const [arataMoadalDetalii, setArataModalDetalii] = useState(false);
  const [metricaSelectata, setMetricaSelectata] = useState(null);
  const [seIncarca, setSeIncarca] = useState(false);
  const [ultimaActualizare, setUltimaActualizare] = useState(new Date());

  // KPI-uri Executive - Simulare date în timp real
  const [dateKPI, setDateKPI] = useState({
    venituri: {
      curent: 2450000,
      anterior: 2280000,
      tinta: 2800000,
      trend: 'creștere',
      creștere: 7.5
    },
    clienti: {
      curent: 12847,
      anterior: 11920,
      tinta: 15000,
      trend: 'creștere',
      creștere: 7.8
    },
    conversie: {
      curent: 24.6,
      anterior: 22.1,
      tinta: 30.0,
      trend: 'creștere',
      creștere: 11.3
    },
    satisfactie: {
      curent: 94.2,
      anterior: 92.8,
      tinta: 95.0,
      trend: 'creștere',
      creștere: 1.5
    }
  });

  // Insights Business Intelligence
  const insightsAfaceri = [
    {
      id: 1,
      titlu: "Accelerare Creștere Venituri",
      descriere: "Veniturile T1 au depășit țintele cu 15%. Recomandăm creșterea bugetului marketing cu 20%.",
      impact: "Ridicat",
      tip: "oportunitate",
      prioritate: 1,
      departament: "Vânzări",
      actiuneNecesara: true,
      valoareEstimata: "420.000 RON"
    },
    {
      id: 2,
      titlu: "Risc Pierdere Clienți Detectat",
      descriere: "3 clienți enterprise prezintă angajament scăzut. Intervenție imediată necesară.",
      impact: "Critic",
      tip: "risc",
      prioritate: 1,
      departament: "Succes Clienți",
      actiuneNecesara: true,
      valoareEstimata: "-180.000 RON"
    },
    {
      id: 3,
      titlu: "Câștig Eficiență Operațională",
      descriere: "Automatizarea AI a redus timpul de procesare cu 35%. Considerăm extinderea la alte departamente.",
      impact: "Mediu",
      tip: "succes",
      prioritate: 2,
      departament: "Operațiuni",
      actiuneNecesara: false,
      valoareEstimata: "85.000 RON"
    },
    {
      id: 4,
      titlu: "Oportunitate Expansiune Piață",
      descriere: "Semnale puternice de cerere din piața germană. Considerăm investiția în localizare.",
      impact: "Ridicat",
      tip: "oportunitate",
      prioritate: 2,
      departament: "Strategie",
      actiuneNecesara: true,
      valoareEstimata: "650.000 RON"
    }
  ];

  // Performanța Departamentelor
  const performantaDepartamente = [
    { 
      nume: 'Vânzări', 
      performanta: 112, 
      tinta: 100, 
      trend: 'creștere',
      buget: '580.000 RON',
      bugetFolosit: 78,
      metriciCheie: { tranzactii: 247, conversie: '18,5%', pipeline: '2,1 mil. RON' }
    },
    { 
      nume: 'Marketing', 
      performanta: 95, 
      tinta: 100, 
      trend: 'scădere',
      buget: '320.000 RON',
      bugetFolosit: 85,
      metriciCheie: { leaduri: 1847, cac: '125 RON', roas: '4,2x' }
    },
    { 
      nume: 'Operațiuni', 
      performanta: 108, 
      tinta: 100, 
      trend: 'creștere',
      buget: '450.000 RON',
      bugetFolosit: 72,
      metriciCheie: { eficienta: '94%', incidente: 3, automatizare: '67%' }
    },
    { 
      nume: 'Succes Clienți', 
      performanta: 118, 
      tinta: 100, 
      trend: 'creștere',
      buget: '280.000 RON',
      bugetFolosit: 68,
      metriciCheie: { satisfactie: '94,2%', pierderi: '2,1%', expansiune: '24%' }
    }
  ];

  // Alerte în timp real
  const [alerte, setAlerte] = useState([
    { id: 1, tip: 'critic', mesaj: 'Performanța sistemului scăzută cu 15%', marcajTemporal: 'acum 2 min', rezolvata: false },
    { id: 2, tip: 'atentionare', mesaj: 'Ținta veniturilor lunare la 89%', marcajTemporal: 'acum 15 min', rezolvata: false },
    { id: 3, tip: 'succes', mesaj: 'Client enterprise nou achiziționat', marcajTemporal: 'acum 1 oră', rezolvata: true }
  ]);

  // Opțiuni interval timp
  const intervaluriTimp = [
    { valoare: '7z', eticheta: '7 Zile' },
    { valoare: '30z', eticheta: '30 Zile' },
    { valoare: '90z', eticheta: '90 Zile' },
    { valoare: '1a', eticheta: '1 An' }
  ];

  // Formatare monedă
  const formateazaMoneda = (suma) => {
    return new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency: 'RON',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(suma);
  };

  // Formatare număr
  const formateazaNumar = (numar) => {
    return new Intl.NumberFormat('ro-RO').format(numar);
  };

  // Gestionare reactualizare date
  const gestioneazaReactualizareDate = async () => {
    setSeIncarca(true);
    
    // Simulează apel API
    setTimeout(() => {
      setUltimaActualizare(new Date());
      setSeIncarca(false);
      
      // Simulează schimbări mici în date
      setDateKPI(prev => ({
        ...prev,
        venituri: {
          ...prev.venituri,
          curent: prev.venituri.curent + Math.random() * 10000 - 5000
        }
      }));
    }, 2000);
  };

  // Arată detalii metrică
  const arataDetaliiMetrica = (metrica) => {
    setMetricaSelectata(metrica);
    setArataModalDetalii(true);
  };

  // Obține afișare trend
  const obtinetrendAfisare = (trend, crestere) => {
    const estePositiv = trend === 'creștere';
    const Icon = estePositiv ? ArrowUpRight : ArrowDownRight;
    const clasaCuloare = estePositiv ? 'text-green-500' : 'text-red-500';
    const clasaFundal = estePositiv ? 'bg-green-50 dark:bg-green-900/20' : 'bg-red-50 dark:bg-red-900/20';
    
    return (
      <div className={`flex items-center space-x-1 px-2 py-1 rounded-full ${clasaFundal}`}>
        <Icon className={`w-4 h-4 ${clasaCuloare}`} />
        <span className={`text-sm font-medium ${clasaCuloare}`}>{Math.abs(crestere)}%</span>
      </div>
    );
  };

  // Obține culoare insight
  const obtinetCuloareInsight = (tip, impact) => {
    switch(tip) {
      case 'oportunitate': return 'border-l-green-500 bg-green-50 dark:bg-green-900/20';
      case 'risc': return 'border-l-red-500 bg-red-50 dark:bg-red-900/20';
      case 'succes': return 'border-l-blue-500 bg-blue-50 dark:bg-blue-900/20';
      default: return 'border-l-gray-500 bg-gray-50 dark:bg-gray-900/20';
    }
  };

  const obtineBadgeImpact = (impact) => {
    const culori = {
      'Critic': 'error',
      'Ridicat': 'warning', 
      'Mediu': 'info',
      'Scăzut': 'success'
    };
    return <Badge variant={culori[impact] || 'default'}>{impact}</Badge>;
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center">
            <BarChart3 className="w-8 h-8 mr-3 text-blue-500" />
            Dashboard Executiv
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Business intelligence în timp real și insights strategice
          </p>
        </div>
        
        <div className="flex items-center space-x-4">
          {/* Selector Interval Timp */}
          <select 
            value={intervalTimp}
            onChange={(e) => setIntervalTimp(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          >
            {intervaluriTimp.map(interval => (
              <option key={interval.valoare} value={interval.valoare}>{interval.eticheta}</option>
            ))}
          </select>
          
          {/* Buton Reactualizare */}
          <button 
            onClick={gestioneazaReactualizareDate}
            disabled={seIncarca}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors disabled:opacity-50"
          >
            <RefreshCw className={`w-4 h-4 ${seIncarca ? 'animate-spin' : ''}`} />
            <span>Reactualizează</span>
          </button>
          
          <button className="flex items-center space-x-2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <Download className="w-4 h-4" />
            <span>Exportă</span>
          </button>
        </div>
      </div>

      {/* Alerte în timp real */}
      {alerte.filter(alerta => !alerta.rezolvata).length > 0 && (
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-4 rounded-r-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <AlertTriangle className="w-5 h-5 text-yellow-500 mr-2" />
              <span className="font-medium text-yellow-800 dark:text-yellow-200">
                {alerte.filter(alerta => !alerta.rezolvata).length} alerte active necesită atenție
              </span>
            </div>
            <button className="text-yellow-600 hover:text-yellow-800 text-sm font-medium">
              Vezi Toate
            </button>
          </div>
        </div>
      )}

      {/* Carduri KPI Executive */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card 
          className="hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => arataDetaliiMetrica('venituri')}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Total Venituri</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">
                {formateazaMoneda(dateKPI.venituri.curent)}
              </p>
              <div className="flex items-center space-x-2 mt-2">
                {obtinetrendAfisare(dateKPI.venituri.trend, dateKPI.venituri.creștere)}
                <span className="text-xs text-gray-500">față de perioada anterioară</span>
              </div>
            </div>
            <DollarSign className="w-8 h-8 text-green-500" />
          </div>
          <div className="mt-4">
            <div className="flex justify-between text-xs text-gray-600 dark:text-gray-400 mb-1">
              <span>Țintă: {formateazaMoneda(dateKPI.venituri.tinta)}</span>
              <span>{Math.round(dateKPI.venituri.curent / dateKPI.venituri.tinta * 100)}%</span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
              <div 
                className="bg-green-500 h-2 rounded-full" 
                style={{ width: `${Math.min(dateKPI.venituri.curent / dateKPI.venituri.tinta * 100, 100)}%` }}
              ></div>
            </div>
          </div>
        </Card>

        <Card 
          className="hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => arataDetaliiMetrica('clienti')}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Clienți Activi</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">
                {formateazaNumar(dateKPI.clienti.curent)}
              </p>
              <div className="flex items-center space-x-2 mt-2">
                {obtinetrendAfisare(dateKPI.clienti.trend, dateKPI.clienti.creștere)}
                <span className="text-xs text-gray-500">rată de creștere</span>
              </div>
            </div>
            <Users className="w-8 h-8 text-blue-500" />
          </div>
        </Card>

        <Card 
          className="hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => arataDetaliiMetrica('conversie')}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Rată Conversie</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">
                {dateKPI.conversie.curent}%
              </p>
              <div className="flex items-center space-x-2 mt-2">
                {obtinetrendAfisare(dateKPI.conversie.trend, dateKPI.conversie.creștere)}
                <span className="text-xs text-gray-500">îmbunătățire</span>
              </div>
            </div>
            <Target className="w-8 h-8 text-purple-500" />
          </div>
        </Card>

        <Card 
          className="hover:shadow-lg transition-shadow cursor-pointer"
          onClick={() => arataDetaliiMetrica('satisfactie')}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">Scor Satisfacție</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">
                {dateKPI.satisfactie.curent}%
              </p>
              <div className="flex items-center space-x-2 mt-2">
                {obtinetrendAfisare(dateKPI.satisfactie.trend, dateKPI.satisfactie.creștere)}
                <span className="text-xs text-gray-500">feedback clienți</span>
              </div>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </Card>
      </div>

      {/* Business Insights & Department Performance */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Business Intelligence Insights */}
        <div className="lg:col-span-2">
          <Card title="Insights Business Intelligence" icon={Zap}>
            <div className="space-y-4">
              {insightsAfaceri.map((insight) => (
                <div key={insight.id} className={`p-4 border-l-4 rounded-r-lg ${obtinetCuloareInsight(insight.tip, insight.impact)}`}>
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 mb-2">
                        <h4 className="font-semibold text-gray-900 dark:text-white">{insight.titlu}</h4>
                        {obtineBadgeImpact(insight.impact)}
                        {insight.actiuneNecesara && (
                          <Badge variant="warning">Acțiune Necesară</Badge>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">{insight.descriere}</p>
                      <div className="flex items-center space-x-4 text-xs text-gray-500">
                        <span className="flex items-center">
                          <Building className="w-3 h-3 mr-1" />
                          {insight.departament}
                        </span>
                        <span className="font-semibold">{insight.valoareEstimata}</span>
                      </div>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              ))}
              <button className="w-full py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg text-gray-600 dark:text-gray-400 hover:border-blue-400 hover:text-blue-500 transition-colors">
                Vezi Toate Insights-urile ({insightsAfaceri.length + 12} total)
              </button>
            </div>
          </Card>
        </div>

        {/* Performanța Departamentelor */}
        <div>
          <Card title="Performanța Departamentelor" icon={Activity}>
            <div className="space-y-4">
              {performantaDepartamente.map((dept) => (
                <div key={dept.nume} className="p-3 border rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-semibold text-gray-900 dark:text-white">{dept.nume}</span>
                    <div className="flex items-center space-x-1">
                      {dept.trend === 'creștere' ? (
                        <TrendingUp className="w-4 h-4 text-green-500" />
                      ) : (
                        <TrendingDown className="w-4 h-4 text-red-500" />
                      )}
                      <span className={`text-sm font-medium ${dept.performanta >= dept.tinta ? 'text-green-600' : 'text-red-600'}`}>
                        {dept.performanta}%
                      </span>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <div className="flex justify-between text-xs text-gray-600 dark:text-gray-400">
                      <span>Performanță vs Țintă</span>
                      <span>{dept.performanta}/{dept.tinta}%</span>
                    </div>
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5">
                      <div 
                        className={`h-1.5 rounded-full ${dept.performanta >= dept.tinta ? 'bg-green-500' : 'bg-yellow-500'}`}
                        style={{ width: `${Math.min(dept.performanta, 100)}%` }}
                      ></div>
                    </div>
                    
                    <div className="flex justify-between text-xs text-gray-600 dark:text-gray-400">
                      <span>Buget Folosit</span>
                      <span>{dept.bugetFolosit}% din {dept.buget}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>

      {/* System Status Footer */}
      <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            <span className="flex items-center text-green-600">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              Toate Sistemele Operaționale
            </span>
            <span className="text-gray-500">Ultima actualizare: {ultimaActualizare.toLocaleTimeString()}</span>
          </div>
          <div className="flex items-center space-x-4">
            <span className="flex items-center text-gray-600">
              <Globe className="w-4 h-4 mr-1" />
              Multi-regiune activ
            </span>
            <span className="flex items-center text-gray-600">
              <Shield className="w-4 h-4 mr-1" />
              Scor securitate: 98%
            </span>
          </div>
        </div>
      </div>

      {/* Modal Detalii */}
      <Modal
        isOpen={arataMoadalDetalii}
        onClose={() => setArataModalDetalii(false)}
        title={`${metricaSelectata && metricaSelectata.charAt(0).toUpperCase() + metricaSelectata.slice(1)} Detalii`}
      >
        {metricaSelectata && (
          <div className="space-y-4">
            <div className="text-center p-6 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
              <p className="text-3xl font-bold text-blue-600">
                {metricaSelectata === 'venituri' ? formateazaMoneda(dateKPI[metricaSelectata].curent) : 
                 metricaSelectata === 'clienti' ? formateazaNumar(dateKPI[metricaSelectata].curent) :
                 dateKPI[metricaSelectata].curent + '%'}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Valoare Curentă</p>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center p-4 border rounded-lg">
                <p className="text-lg font-semibold text-gray-900 dark:text-white">
                  {metricaSelectata === 'venituri' ? formateazaMoneda(dateKPI[metricaSelectata].anterior) : 
                   metricaSelectata === 'clienti' ? formateazaNumar(dateKPI[metricaSelectata].anterior) :
                   dateKPI[metricaSelectata].anterior + '%'}
                </p>
                <p className="text-xs text-gray-500">Perioada Anterioară</p>
              </div>
              <div className="text-center p-4 border rounded-lg">
                <p className="text-lg font-semibold text-gray-900 dark:text-white">
                  {metricaSelectata === 'venituri' ? formateazaMoneda(dateKPI[metricaSelectata].tinta) : 
                   metricaSelectata === 'clienti' ? formateazaNumar(dateKPI[metricaSelectata].tinta) :
                   dateKPI[metricaSelectata].tinta + '%'}
                </p>
                <p className="text-xs text-gray-500">Țintă</p>
              </div>
            </div>

            <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <div className="flex items-center justify-between">
                <span className="text-green-800 dark:text-green-200 font-medium">Rată Creștere</span>
                <span className="text-green-600 font-bold text-lg">+{dateKPI[metricaSelectata].creștere}%</span>
              </div>
            </div>

            <div className="flex space-x-2">
              <button className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition-colors">
                Vezi Raport Detaliat
              </button>
              <button className="flex-1 border border-gray-300 dark:border-gray-600 py-2 px-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                Setează Alertă
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default DashboardExecutiv;